import React, { useContext } from 'react';
import StudentNav from '../../Navbars/StudentNav';
import AdminNav from '../../Navbars/AdminNav';
import TeacherNav from '../../Navbars/TeacherNav';
import GuestNav from '../../Navbars/GuestNav';
import { UserContext } from '../../UserContext';

/**
 * Common navigation component for all activities
 * @param {Object} props - Component props
 * @param {Function} props.onLogout - Logout handler function
 * @param {Function} props.onCourseSelect - Course selection handler (for teachers)
 * @returns {JSX.Element} Navigation component
 */
const ActivityNavigation = ({ onLogout, onCourseSelect }) => {
  const { isAdmin, isTeacher, isStudent, isGuest, userInfo } = useContext(UserContext);
  
  const username = userInfo?.username;
  const avatar = userInfo?.avatar;

  // Default logout handler if none provided
  const handleLogout = onLogout || (() => {
    console.log('Default logout handler');
  });

  // Default course select handler if none provided
  const handleCourseSelect = onCourseSelect || ((course) => {
    console.log('Selected Course:', course);
  });

  return (
    <>
      {username && (
        <>
          {isAdmin && (
            <AdminNav
              username={username}
              avatar={avatar}
              onLogout={handleLogout}
            />
          )}
          {isTeacher && (
            <TeacherNav
              onCourseSelect={handleCourseSelect}
              username={username}
              avatar={avatar}
              onLogout={handleLogout}
            />
          )}
          {isStudent && (
            <StudentNav
              username={username}
              avatar={avatar}
              onLogout={handleLogout}
            />
          )}
        </>
      )}
      {!username && isGuest && (
        <GuestNav onLogin={(usertype) => {
          // This would need to be handled by the parent component
          console.log('Login requested for:', usertype);
        }} />
      )}
    </>
  );
};

export default ActivityNavigation;
